<!-- Copyright (c) 2009-2022. Authors: see NOTICE file.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

      http://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.-->

<template>
  <div class="navbar-item has-dropdown is-hoverable">
    <div class="navbar-link" :class="{ 'is-active': isActive, ...linkClasses }" tabindex="0">
      <i v-if="icon" :class="[iconPack, icon]"></i>
      <span class="navbar-link-title">{{ title }}</span>
      <!-- <b-tag v-if="tag" :type="tag.type">{{tag.text}}</b-tag> -->
    </div>
    <div class="navbar-dropdown" :class="classes">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'navbar-dropdown',
  props: {
    icon: String,
    iconPack: { type: String, default: 'fas' },
    title: String,
    tag: Object,
    classes: Array,
    linkClasses: Object,
    listPathes: Array
  },
  data() {
    return {
      isActive: false
    };
  },
  watch: {
    '$route.path': {
      handler() {
        if (this.listPathes) {
          this.isActive = !!this.listPathes.find(p => this.$route.path.match(p));
        }
        // required so dropdown doesn't remain open on route change.
        document.activeElement.blur();
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss">
@import '../../assets/styles/dark-variables';

.navbar-item .tag {
  margin-left: 0.5rem;
}

.navbar-item.has-dropdown .navbar-link {
  background-color: transparent !important;
  color: $dark-text-secondary !important;
  border-radius: 6px;
  font-weight: 650;
  letter-spacing: 0;
  transition: color 0.16s ease, background-color 0.16s ease;
}

.navbar-link-title {
  margin-left: 0.35rem;
}

.navbar-item.has-dropdown .navbar-link::after {
  border-color: rgba($primary, 0.78) !important;
}

.navbar-item.has-dropdown .navbar-link:hover,
.navbar-item.has-dropdown .navbar-link.is-active {
  background-color: rgba($primary, 0.11) !important;
  color: #b9f4fb !important;
}

.navbar-dropdown {
  background:
    linear-gradient(180deg, rgba(222, 238, 255, 0.04), rgba(222, 238, 255, 0.012)),
    rgba(13, 25, 42, 0.98) !important;
  color: $dark-text-primary !important;
  border: 1px solid rgba(190, 214, 238, 0.18) !important;
  border-top: none !important;
  border-radius: 8px !important;
  box-shadow: 0 20px 48px rgba(0, 0, 0, 0.34);
  padding: 0.35rem !important;
  backdrop-filter: blur(14px);
}

.navbar-dropdown .navbar-item {
  background-color: transparent !important;
  color: $dark-text-secondary !important;
  border-radius: 6px;
  font-size: 0.88rem;
  font-weight: 600;
  line-height: 1.2;
  min-height: 2.2rem;
}

.navbar-dropdown .navbar-item:hover {
  background-color: rgba($primary, 0.13) !important;
  color: $dark-text-primary !important;
}

@media screen and (min-width: 1024px) {
  .navbar-item.is-hoverable:hover .navbar-dropdown {
    display: block;
  }

  .navbar-item.is-hoverable:focus-within:not(:hover) .navbar-dropdown {
    display: none;
  }
}
</style>
